module.exports = __webpack_public_path__ + "img/haveing-icon.d4e9b733.png";